import styled from "styled-components";
import { Box } from "@mui/material";

import colors from "../../styles/colors/colors";
import fontWeight from "../../styles/mui/fontWeight";

export const ReadOnlyFieldContainer = () => ({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    minWidth: 0,
    color: colors.black[1],
  });
  
  export const ReadOnlyFieldLabel = () => ({
    marginBottom: "0.25rem",
    whiteSpace: "nowrap",
  });
  
  export const ReadOnlyFieldValue = () => ({
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    width: "100%",
    wordBreak: "break-word",
    overflowWrap: "anywhere",
    minHeight: "1.8rem"
  });
  
  export const ReadOnlyFieldIcon = () => ({
    marginTop: "0.15rem",
    flexShrink: 0,
    alignItems: "center",
  });
  
  export const ReadOnlyFieldValueStyle = () => ({
    wordBreak: "break-word",
    overflowWrap: "anywhere",
  });
export const ButtonVerifyStyle = {
  borderRadius: "0.3125rem",
  backgroundColor: colors.primary.main,
};

  export const CustomPaginationButton = () => ({
    width: "auto",
    minWidth: "fit-content",
    textDecoration: "underline",
    color: colors.fonts[4],
    fontWeight: fontWeight.Weight[5],
    padding: "0.2rem 0.4rem 0",
    fontSize: "0.75rem",
  });

  export const ListPageNumber = () => ({
    paddingLeft: "1rem",
  });

  export const PaginationButton = (disabled: boolean) => ({
    width: "auto",
    minWidth: "fit-content",
    textDecoration: disabled ? "none" : "underline",
    color: colors.fonts[4],
    fontWeight: fontWeight.Weight[5],
    padding: "0.2rem 0.4rem 0",
    fontSize: "0.7rem",
  });

  export const ItemPagination = styled(Box)(() => ({
    display: "flex",
    flexDirection: "row",
    justifyContent: "end",
    alignItems: "end",
  }));

  export const TablePaginationStyle = () => ({
    "& .MuiTablePagination-selectLabel": {
      color: colors.fonts[4],
      fontWeight: fontWeight.Weight[2],
      fontSize: "0.8rem",
      alignItems: "center",
    },
    "& .MuiTablePagination-displayedRows": {
      borderLeft: `2px solid ${colors.dropShadow[9]}`,
      paddingLeft: "0.8rem",
      color: colors.fonts[4],
      fontWeight: fontWeight.Weight[2],
      fontSize: "0.8rem",
    },
    "& .MuiInputBase-root": {
      marginRight: "0.5rem",
      marginLeft: 0,
    },
    "& .MuiTablePagination-spacer": {
      display: "none",
    },
  });

  export const PaginationItemStyle = {
    flex: "1 1 100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
  };

  export const HeaderPaperStyle = {
  position: "fixed",
  zIndex: 5,
  width: "100%",
};